export const newGridRecordId = 'temp';
export const newGridRecord = {
  id: newGridRecordId,
  isNew: true,
  createdDate: new Date().toISOString(),
  updatedDate: new Date().toISOString(),
};

export const gridRowActionsIconProps = {
  color: '#33bba5',
  width: 18,
};

export const deCamelize = (word: string | number | symbol = '') => {
  word = String(word);
  const wordRegex = /[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g;
  const [firstWord = '', ...restWords] = word.match(wordRegex) || [];
  return [
    firstWord?.[0]?.toUpperCase() + firstWord?.substring(1),
    ...restWords.map((w) => w?.[0].toUpperCase() + w?.substring(1)),
  ].join(' ');
};

export const downloadAsData = async (
  name: string,
  base64Str: string | undefined | null,
  blobDownloadLink?: string | undefined | null
) => {
  if (blobDownloadLink) {
    try {
      const response = await fetch(blobDownloadLink);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return;
    } catch (error) {
      console.error('Download failed, falling back to new tab', error);
      // If fetch fails (CORS), fallback to opening in new tab
      window.open(blobDownloadLink, '_blank');
      return;
    }
  }

  const element = document.createElement('a');
  element.setAttribute('href', `data:text/plain;base64,${base64Str}`);
  element.setAttribute('download', name);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

export const navigateToLastGridRow = (api: any, pageSize: number) => {
  setTimeout(() => {
    const ids = api.getSortedRowIds();
    const newRowIndex = ids.indexOf(newGridRecordId);
    const lastPage = Math.floor(newRowIndex / pageSize);
    api.setPage(lastPage);
    api.scrollToIndexes({
      rowIndex: newRowIndex,
    });
  });
};
